var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c(
        "el-tabs",
        {
          staticClass: "mb-0 bg-white",
          attrs: { type: "card" },
          on: { "tab-click": _vm.selDataType },
          model: {
            value: _vm.listQuery.sel_agent_level,
            callback: function ($$v) {
              _vm.$set(_vm.listQuery, "sel_agent_level", $$v)
            },
            expression: "listQuery.sel_agent_level",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "全部", name: "0" } }),
          _vm._v(" "),
          _vm.agentInfo.agent_level < 1
            ? _c("el-tab-pane", { attrs: { label: "贴牌", name: "1" } })
            : _vm._e(),
          _vm._v(" "),
          _vm.agentInfo.agent_level < 2
            ? _c("el-tab-pane", { attrs: { label: "合伙人", name: "2" } })
            : _vm._e(),
          _vm._v(" "),
          _vm.agentInfo.agent_level < 3
            ? _c("el-tab-pane", { attrs: { label: "代理商", name: "3" } })
            : _vm._e(),
          _vm._v(" "),
          _vm.agentInfo.agent_level < 4
            ? _c("el-tab-pane", { attrs: { label: "业务员", name: "4" } })
            : _vm._e(),
          _vm._v(" "),
          _vm.agentInfo.agent_level < 5
            ? _c("el-tab-pane", { attrs: { label: "商家", name: "5" } })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticClass: "p-10 bg-white",
        },
        [
          _c(
            "div",
            { staticClass: "mb-10 flex align-center" },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "daterange",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  size: "small",
                  "value-format": "yyyy-MM-dd",
                },
                on: { change: _vm.handleDateChange },
                model: {
                  value: _vm.listQuery.date_range,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQuery, "date_range", $$v)
                  },
                  expression: "listQuery.date_range",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "flex1" }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary", plain: "" },
                  on: {
                    click: function ($event) {
                      return _vm.outTab("operate_data")
                    },
                  },
                },
                [
                  _vm._v("导出"),
                  _c("i", { staticClass: "el-icon-male el-icon--right" }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              attrs: {
                id: "operate_data",
                data: _vm.list,
                stripe: "",
                border: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "名称" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              scope.row.name
                                ? scope.row.name
                                : scope.row.nick_name
                            ) +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "角色" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(scope.row.role_name) +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "运营区域" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            _vm._s(scope.row.charge_province) +
                              _vm._s(
                                scope.row.charge_city
                                  ? "，" + scope.row.charge_city
                                  : ""
                              ) +
                              _vm._s(
                                scope.row.charge_county
                                  ? "，" + scope.row.charge_county
                                  : ""
                              )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "总交易额" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(scope.row.order_total_amount) +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "本月交易额" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(scope.row.order_month_amount) +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "今日交易额" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(scope.row.order_today_amount) +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "昨日交易额" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n           " +
                            _vm._s(scope.row.order_yesterday_amount) +
                            "\n         "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "总订单数" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(scope.row.order_total_num) +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "本月订单数" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(scope.row.order_month_num) +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "今日订单数" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(scope.row.order_today_num) +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "昨日订单数" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(scope.row.order_yesterday_num) +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "总商户" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(scope.row.store_num) +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "总底座" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(scope.row.all_zuo_num) +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "已铺货底座" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(scope.row.devoted_zuo_num) +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "p-20 flex justify-center" },
            [
              _c("pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listQuery.page_num > 0,
                    expression: "listQuery.page_num > 0",
                  },
                ],
                attrs: {
                  page: _vm.listQuery.start,
                  limit: _vm.listQuery.limit,
                  "page-count": parseInt(_vm.listQuery.page_num),
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.listQuery, "start", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.listQuery, "limit", $event)
                  },
                  pagination: _vm.getList,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }